<article class="alert" [ngClass]="'alert--' + status" class="alert" role="alert">
  <h2 class="type-body-sm font-secondary fw-bold mb-2 h6" *ngIf="title">{{ title }}</h2>
  <p class="mb-0" *ngIf="message">{{ message }}</p>

  <ng-content></ng-content>
</article>
